'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Bhandari Vadhu Var Suchak Mandal Sindhudurg" },
  { label: "Bhandari Vadhu Var Suchak Mandal Photos" },
  { label: "Bhandari Vadhu Var Suchak Mandal Goa" },
  { label: "Bhandari Vadhu Var Suchak Mandal Reviews" },
  { label: "Bhandari Vadhu Var Suchak Mandal Ratnagiri" },
  { label: "Kitte Bhandari Vadhu Var Suchak Mandal" },
  { label: "Kitte Bhandari Vadhu Var Suchak Mandal Dadar" },
  { label: "Bhandari Vadhu Var Suchak Kendra" },
  { label: "Goan Bhandari Vadhu" },
  { label: "Kitte Bhandari Vadhu List" },
  { label: "Bhandari Vadhu Ratnagiri" },
  { label: "Bhandari Vadhu Var Suchak Mandal in Thane" },
  { label: "Bhandari Vadhu Var Suchak Mandal Mulund" },
  { label: "Bhandari Vadhu Var Suchak Mandal Dadar" },
  { label: "Kitte Bhandari Vadhu List Dadar" },
  { label: "Bhandari Vadhu Var Melava" },
  { label: "Bhandari Vadhu List" },
  { label: "Panvel Bhandari Vadhu Var Mandal" },
  { label: "Hetkari Bhandari Hall Dadar" },
  { label: "Hetkari Bhandari Mandal Dadar" },
  { label: "Hetkari Bhandari Dadar" },
  { label: "Hetkari Bhandari Caste" },
  { label: "Hetkari Bhandari Matrimony" },
  { label: "Hetkari Bhandari Samaj Dadar" },
  { label: "Kitte Bhandari Hall" },
  { label: "Kitte Bhandari Hall Dadar" },
  { label: "Kitte Bhandari Hall Dadar West Contact Number" },
  { label: "Kitte Bhandari Caste" },
  { label: "Kitte Bhandari Hall Dadar Address" },
  { label: "Kitte Bhandari Hall Dadar West" },
  { label: "Kitte Bhandari Vadhu Var Suchak Mandal" },
  { label: "Kitte Bhandari Vadhu Var Suchak Mandal Dadar" },
  { label: "Kitte Bhandari Samaj" },
  { label: "Kitte Bhandari Vadhu List" },
  { label: "Kitte Bhandari Vivah Mandal" },
  { label: "Kitte Bhandari Dadar" },
  { label: "Kitte Bhandari Hall Contact Number" },
  { label: "Kitte Bhandari List" },
  { label: "Kitte Bhandari Hall Address" },
  { label: "Kitte Bhandari Mandal" },
  { label: "Kitte Bhandari Bride" },
  { label: "Kitte Bhandari Vadhu List Dadar" },
  { label: "Kitte Bhandari Vivah Mandal Dadar" },
];

export default function BhandariVadhuVarSuchakMandal() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="कित्ते भंडारी आणि हेतकरी भंडारी वधू-वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="bhandari_vadhu_var_suchak_mandal"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "Which is best Bhandari Vadhu Var Suchak Mandal Sawantwadi?",
                  answer: "MarathiVadhuVarSuchak.com plaform is most trusted Bhandari Vadhu Var Suchak Mandal in Sawantwadi and Mumbai."
                },
                {
                  question: "How to search Bhandari vadhu var suchak mandal photos?",
                  answer: "Visit MarathiVadhuVarSuchak.com plaform to register free and search Bhandari vadhu var suchak Mandal photos with profiles."
                },
                {
                  question: "What is the Bhandari vadhu var suchak mandal contact number?",
                  answer: "Bhandari vadhu var can get contact number through MarathiVadhuVarSuchak.com plaform."
                },
                {
                  question: "How to visit Bhandari Vadhu Var Suchak Mandal Dadar?",
                  answer: "Use internet to save the time. Bhandari vadhu var can visit MarathiVadhuVarSuchak.com plaform to register free."
                },
                {
                  question: "What about Bhandari Vadhu Var Suchak Mandal reviews?",
                  answer: "MarathiVadhuVarSuchak.com plaform is the most trusted for Bhandari Vadhu Var in Maharashtra."
                },
                {
                  question: "Which is the best Bhandari Vadhu Var Suchak Mandal in Thane?",
                  answer: "Bhandari Vadhu Var can register through MarathiVadhuVarSuchak.com matrimony without visiting any office."
                },
                {
                  question: "Which is the best Bhandari Vadhu Var Suchak Mandal Mumbai Maharashtra?",
                  answer: "MarathiVadhuVarSuchak.com Marathi matrimony is the best Bhandari Vadhu Var Suchak Mandal in Mumbai Maharashtra."
                },
                {
                  question: "What is the Bhandari Vadhu Var Suchak Mandal Mangalashtak Vengurla registration process?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony for online free registration."
                },
                {
                  question: "Which is the best Vadhu Var Suchak Mandal Marathi?",
                  answer: "MarathiVadhuVarSuchak.com is the best Vadhu Var Suchak Mandal for Marathi Vadhu Var."
                },
                {
                  question: "Which is the best Vadhu Var Suchak Mandal near me?",
                  answer: "MarathiVadhuVarSuchak.com is the best Vadhu Var Suchak Mandal to register online from anywhere."
                },
                {
                  question: "Which is the trusted online Vadhu Var Suchak Mandal?",
                  answer: "MarathiVadhuVarSuchak.com is the most trusted online Vadhu Var Suchak Mandal in Maharashtra."
                },
                {
                  question: "How to get Kitte Bhandari Vadhu list Dadar?",
                  answer: "Register free on MarathiVadhuVarSuchak.com and after approval you can get Kitte Bhandari Vadhu Var list online."
                },
                {
                  question: "Which is the best Kitte Bhandari Vadhu Var Suchak Mandal?",
                  answer: "MarathiVadhuVarSuchak.com is the best Kitte Bhandari Vadhu Var Suchak Mandal in Maharashtra state."
                },
                {
                  question: "Where is the Kitte Bhandari Hall Dadar?",
                  answer: "Kitte Bhandari Hall Dadar is near to Shivsena Bhawan in Mumbai Dadar."
                },
                {
                  question: "Which is the Kitte Bhandari website?",
                  answer: "MarathiVadhuVarSuchak.com is the best website available for Kitte Bhandari Vadhu Var registration."
                },
                {
                  question: "Where is the Kitte bhandari Aikyawardhak Mandal Dadar West?",
                  answer: "Kitte bhandari Aikyawardhak Mandal Dadar West is near to Shivsena Bhawan."
                },
                {
                  question: "Which is the best Hetkari Bhandari matrimony site?",
                  answer: "MarathiVadhuVarSuchak.com is the best Hetkari Bhandari matrimony site in Maharashtra."
                },
                {
                  question: "Which category Bhandari comes under?",
                  answer: "The Bhandari caste is categorized under the Other Backward Class (OBC) list in Goa and Maharashtra state."
                },
                {
                  question: "Which caste is Hetkari Bhandari?",
                  answer: "The Hetkari Bhandari caste is categorized under the Other Backward Class (OBC) list in Goa and Maharashtra state."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Bhandari Vadhu Var Suchak Mandal for Kitte Bhandari and Hetkari Bhandari"
        items={communityServices}
      />

    </div>
  );
}

